/**
 * Alert tone via WebAudio.
 *
 * No audio file to ship or preload, and no autoplay fight: the context is
 * created lazily on the first user gesture and resumed if the browser suspends
 * it, which is what happens when the tab has been backgrounded a while.
 */

let context: AudioContext | null = null;

function ensureContext(): AudioContext | null {
  if (typeof AudioContext === "undefined") return null;
  context ??= new AudioContext();
  if (context.state === "suspended") void context.resume();
  return context;
}

/** Called from a click handler so the context starts in a permitted state. */
export function primeAudio(): void {
  ensureContext();
}

/** Two rising notes — distinct enough to notice without being an alarm. */
export function playDealSound(): void {
  const ctx = ensureContext();
  if (!ctx) return;

  const now = ctx.currentTime;
  const gain = ctx.createGain();
  gain.gain.setValueAtTime(0.0001, now);
  gain.connect(ctx.destination);

  const play = (frequency: number, start: number, duration: number) => {
    const osc = ctx.createOscillator();
    osc.type = "sine";
    osc.frequency.setValueAtTime(frequency, now + start);
    osc.connect(gain);
    osc.start(now + start);
    osc.stop(now + start + duration);
  };

  gain.gain.exponentialRampToValueAtTime(0.22, now + 0.02);
  gain.gain.exponentialRampToValueAtTime(0.18, now + 0.16);
  gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.42);

  play(880, 0, 0.16);
  play(1318.5, 0.16, 0.24);
}
